import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const leaseIssue: ISVGPersonalProps = {
  viewBox: '0 0 28 28',
  content: (
    <g id="issue_icon_active" data-name="issue icon active" transform="translate(18459.691 2947.492)">
      <rect
        id="Rectangle_2788"
        data-name="Rectangle 2788"
        width="28"
        height="28"
        transform="translate(-18459.691 -2947.492)"
        fill="none"
      />
      <g id="Group_2332" data-name="Group 2332" transform="translate(-18455.984 -2933.435)">
        <path
          id="Path_1148"
          data-name="Path 1148"
          d="M3.936,306.585a.934.934,0,0,1-.224-.027.922.922,0,0,1-.573-.421L.134,301.167a.93.93,0,0,1,.314-1.275l1.461-.883a.929.929,0,0,1,1.275.314l3.006,4.969a.93.93,0,0,1-.314,1.275l-1.461.883a.923.923,0,0,1-.479.134m-1.547-7.211a.428.428,0,0,0-.222.062l-1.461.883a.43.43,0,0,0-.145.59l3.005,4.969a.43.43,0,0,0,.59.145l1.46-.883a.43.43,0,0,0,.145-.59l-3.005-4.969a.43.43,0,0,0-.369-.207m3.358,5.98h0Z"
          transform="translate(0 -296.776)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.8"
        />
        <path
          id="Path_1149"
          data-name="Path 1149"
          d="M200.547,319.156a.249.249,0,0,1-.024-.5l2.283-.224a.995.995,0,0,0,.9-1.023.249.249,0,0,1,.5-.018,1.494,1.494,0,0,1-1.346,1.538l-2.283.224h-.025"
          transform="translate(-189.215 -314.044)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.8"
        />
        <path
          id="Path_1150"
          data-name="Path 1150"
          d="M64.284,268.33q-.143,0-.287-.009l-.108-.008-4.059-.348a5.313,5.313,0,0,0-.715-.012c-.072,0-.147.009-.236.018a5.233,5.233,0,0,0-1.243.278.249.249,0,1,1-.167-.47,5.733,5.733,0,0,1,1.362-.3c.1-.01.181-.016.261-.02a5.838,5.838,0,0,1,.781.013l4.058.348.1.007a4.345,4.345,0,0,0,2.937-.929c1.718-1.342,4.642-3.652,4.671-3.675a.992.992,0,0,0,.371-.876.994.994,0,0,0-1.607-.681L66.818,264.5a.249.249,0,0,1-.4-.185c0-.021,0-.043,0-.064a1,1,0,0,0-1.086-.893l-3.141.308a2.409,2.409,0,0,1-1.51-.354,3.751,3.751,0,0,0-4.306.243l-.993.79a.249.249,0,1,1-.31-.39l.994-.791a4.251,4.251,0,0,1,4.88-.275,1.912,1.912,0,0,0,1.2.28l3.141-.308a1.494,1.494,0,0,1,1.555.992l3.26-2.586a1.493,1.493,0,0,1,1.856,2.34c-.03.024-2.955,2.334-4.674,3.677a4.856,4.856,0,0,1-2.988,1.043"
          transform="translate(-51.928 -260.947)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.8"
        />
      </g>
      <g id="Group_4368" data-name="Group 4368" transform="translate(-18449.457 -2943.359)">
        <path
          id="Path_7217"
          data-name="Path 7217"
          d="M6.573,160.039H2.616A2.619,2.619,0,0,1,0,157.422v-4.4A2.619,2.619,0,0,1,2.616,150.4H6.573a2.619,2.619,0,0,1,2.616,2.616v4.4A2.619,2.619,0,0,1,6.573,160.039Zm-3.957-8.614a1.6,1.6,0,0,0-1.6,1.6v4.4a1.6,1.6,0,0,0,1.6,1.6H6.573a1.6,1.6,0,0,0,1.6-1.6v-4.4a1.6,1.6,0,0,0-1.6-1.6Z"
          transform="translate(0 -150.403)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
        <path
          id="Path_7218"
          data-name="Path 7218"
          d="M40.368,1.323a.36.36,0,0,1-.48.026,2.882,2.882,0,0,0-3.595,0,.36.36,0,0,1-.48-.026h0A.359.359,0,0,1,35.839.79a3.6,3.6,0,0,1,4.5,0A.359.359,0,0,1,40.368,1.323Z"
          transform="translate(-33.499 3.588)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
        <path
          id="Path_7219"
          data-name="Path 7219"
          d="M81.243,60.913a.358.358,0,0,1-.45.048,1.443,1.443,0,0,0-1.6,0,.36.36,0,0,1-.391-.6,2.164,2.164,0,0,1,2.378,0A.361.361,0,0,1,81.243,60.913Z"
          transform="translate(-75.404 -54.972)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
      </g>
    </g>
  ),
};
